<template>

  <div class="star-rating">
    <div style="float:left; padding-right: 10px">
      <img width="30px" src="@/assets/images/turkish-restaurant-icon.png"/>
    </div>
    <div class="stars-outer">
      <div class="stars-inner" :style="{ width: starWidth }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rating: {
      type: Number,
      required: true
    }
  },
  computed: {
    starWidth () {
      return `${(this.rating / 5) * 100}%`
    }
  }
}
</script>

<style scoped>
.stars-outer {
  display: inline-block;
  position: relative;
  font-family: 'FontAwesome';
  font-size: 24px;
  color: #ccc; /* Gri renkli yıldızlar */
}
.stars-inner {
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
  overflow: hidden;
  width: 0;
  color: #f24405; /* Sarı renkli yıldızlar */
}
.stars-outer::before {
  content: "★★★★★"; /* 5 adet boş yıldız */
}
.stars-inner::before {
  content: "★★★★★"; /* 5 adet dolu yıldız */
}
</style>
